/**
 * Trading Desk "Optimized" scenarios: the same charging demand optimized
 * against different market price curves.
 */

export type ScenarioKey = 'da' | 'idcfull' | 'cross'

export const SCENARIO_KEYS: readonly ScenarioKey[] = ['da', 'idcfull', 'cross']

export const SCENARIO_LABELS: Record<ScenarioKey, string> = {
  da: 'Optimized DA',
  idcfull: 'Optimized IDCFull',
  cross: 'Optimized Cross-Market',
}

export const SCENARIO_DESCRIPTIONS: Record<ScenarioKey, string> = {
  da: 'Cheapest Day-Ahead slots within the plug-in window.',
  idcfull: 'Cheapest Intraday Continuous full-session-average (ID-Cfull) slots within the plug-in window.',
  cross: 'Cheapest slots from either market: at every 15-min delivery period, the lower of the Day-Ahead and ID-Cfull price is used, then the cheapest slots of that blended curve are filled.',
}

export const SCENARIO_COLORS: Record<ScenarioKey, string> = {
  da: '#f59e0b',
  idcfull: '#a855f7',
  cross: '#0ea5e9',
}

const IDCFULL_ALIASES = ['ID-Cfull', 'IDFull', 'ID-CFull', 'IDCfull']
const IDCFULL_PATTERN = /^id-?c?full$/i

/**
 * The bundled EPEX combined CSV uses the key "ID-Cfull"; the uploaded IDA CSV
 * format uses "IDFull" instead. Resolve either to the actual key present in
 * a given series map.
 */
export function resolveIdcFullKey(series: Record<string, unknown>): string | undefined {
  const keys = Object.keys(series)
  for (const alias of IDCFULL_ALIASES) {
    if (keys.includes(alias)) return alias
  }
  return keys.find((k) => IDCFULL_PATTERN.test(k))
}
